import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaColaboradoresAgregarExcel', {
    template: template,
    controller: NominasNominaColaboradoresAgregarExcelComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
      onClose: '&',
    },
    require: {
      nomina: '^nomina',
    },
  })

function NominasNominaColaboradoresAgregarExcelComponent($catalogos, $filter, $q, NominasNominaInformacionTipocambio) {
  let $ctrl = this,
    orderBy = $filter('orderBy')

  $ctrl.$onInit = $onInit
  $ctrl.cerrar = cerrar
  $ctrl.aceptar = aceptar
  $ctrl.validar = validar
  $ctrl.headers = []
  $ctrl.data = null
  $ctrl.error = null
  $ctrl.alertas = null

  function $onInit() {
    $ctrl.idMoneda = Number($ctrl.nomina.data.id_moneda)

    $ctrl.promise = $q.all([
        NominasNominaInformacionTipocambio.get($ctrl.idProyecto, $ctrl.idNomina)
          .then(function (response) {
            $ctrl.tipoCambio = response.data.tipo_cambio
          }),
        $catalogos.get('movimientos')
          .then(function (conceptos) {
            $ctrl.conceptos = orderBy(conceptos, 'concepto')
          }),
      ])
      .then(function () {
        $ctrl.headers.push({
          id: 'empleado',
          name: 'Nombre del colaborador',
          group: 'REQUERIDO',
          parser: function (value) {
            return value !== '' ? value : null
          },
          processor: function (object, value) {
            object.empleado = value

            return object
          },
          match: function (value) {
            return ['NOMBRE', 'EMPLEADO', 'NOMBRE EMPLEADO', 'NOMBRE DEL EMPLEADO']
              .indexOf(value.toUpperCase()) >= 0
          },
        })

        $ctrl.headers.push({
          id: 'importe',
          name: 'Importe',
          group: 'REQUERIDO',
          parser: function (value) {
            let number = parseNumber(value)
            return number >= 0 ? number : null
          },
          processor: function (object, value) {
            object.importe = value

            return object
          },
          match: function (value) {
            return ['NETO FAN', 'NETO', 'IMPORTE']
              .indexOf(value.toUpperCase()) >= 0
          },
        })

        $ctrl.conceptos
          .filter(function (item) {
            return item.id_tipo_concepto === 0 || item.calculo_importe !== ''
          })
          .forEach(function (item) {
            let naturaleza = item.naturaleza === 'P' ? 'percepciones' : 'deducciones',
              id_concepto = item.id,
              campo = item.editar_horas ? 'horas' : (item.editar_dias ? 'dias' : 'importe')

            $ctrl.headers.push({
              id: naturaleza + '.' + id_concepto + '.' + campo,
              name: item.concepto + (campo !== 'importe' ? ' (' + campo + ')' : ''),
              group: naturaleza.toUpperCase(),
              parser: function (value) {
                let number = parseNumber(value)
                return number > 0 ? number : null
              },
              processor: function (object, value) {
                if (value !== null) {
                  object[naturaleza] = object[naturaleza] || {}
                  object[naturaleza][id_concepto] = object[naturaleza][id_concepto] || {}
                  object[naturaleza][id_concepto][campo] = value
                }

                return object
              },
              data: item,
              match: function (value) {
                return value.toUpperCase() === item.concepto.toUpperCase()
              },
            })
          })
      })
  }

  function cerrar(data) {
    $ctrl.onClose({$event: {data: data}})
  }

  function aceptar() {
    let data = $ctrl.data.map(function (item) {
      let empleado = {
        empleado: item.empleado,
        id_moneda: $ctrl.idMoneda,
        importe: redondear(item.importe * ($ctrl.idMoneda === 1 ? 1 : $ctrl.tipoCambio), 2),
        importe_divisa: $ctrl.idMoneda === 1 ? null : redondear(item.importe, 2),
        tipo_cambio: $ctrl.tipoCambio,
        comision_porcentaje: 0,
        comision_importe: 0,
        neto: 0,
        total_percepciones: 0,
        total_deducciones: 0,
        neto_a_pagar: null,
        status_calculado: 0,
        config: {},
        percepciones: {},
        deducciones: {},
      }

      angular.forEach(item.deducciones, function (value, key) {
        empleado.deducciones[key] = value
      })

      angular.forEach(item.percepciones, function (value, key) {
        empleado.percepciones[key] = value
      })

      return empleado
    })

    cerrar(data)
  }

  function parseNumber(value) {
    return angular.isString(value) || angular.isNumber(value)
      ? parseFloat(value.replace(/[^\d\.\-]/g, ''))
      : value
  }

  function redondear(value, decimals) {
    return parseFloat(value.toFixed(decimals))
  }

  function validar($event) {
    $ctrl.data = null
    $ctrl.error = null
    $ctrl.alertas = []

    if (!$event.headers || !$event.data || !$event.data.length)
      return

    let columnasDuplicadas = []
    $event.headers.map(function (item, index) {
      if (item && columnasDuplicadas.indexOf(item) >= 0)
        $ctrl.error = 'La columna ' + (index + 1) + ' se encuentra duplicada.'
      columnasDuplicadas.push(item)
    })

    if ($ctrl.error)
      return $ctrl.error

    // La columna EMPLEADO es requerida
    if ($event.headers.indexOf('empleado') < 0)
      return $ctrl.error = 'Es necesario seleccionar una columna como NOMBRE DE EMPLEADO'

    // La columna NETO es requerida
    if ($event.headers.indexOf('importe') < 0)
      return $ctrl.error = 'Es necesario seleccionar una columna como IMPORTE'

    // Filtrar los registros con campo EMPLEADO O NETO
    let registros = $event.data.filter(function (item) {
      return item['empleado'] !== null && item['importe'] !== null && item['importe'] > 0
    })

    if (!registros.length)
      return $ctrl.error = 'Ninguna fila contiene información para importar'

    // Revisar si hay duplicados
    /*let index      = [],
        duplicados = [];

    $event.data.forEach(function (item) {
      if (item["empleado"] && index.indexOf(item["empleado"]) >= 0)
        duplicados.push(item["empleado"]);

      index.push(item["empleado"]);
    });

    if (duplicados.length)
      return $ctrl.error = "El registro " + duplicados[0] + " se encuentra duplicado, elimine uno para poder continuar.";
    */
    $event.headers.forEach(function (item, index) {
      if (item === null)
        $ctrl.alertas.push('La columna ' + (index + 1) + ' se omitirá pues no se especificó un encabezado.')
    })

    $event.data.forEach(function (item, index) {
      if (item['empleado'] === null)
        return $ctrl.alertas.push('La fila ' + (index + 1) + ' se omitirá pues no se especificó el nombre del empleado.')

      if (item['importe'] === null || item['importe'] <= 0)
        return $ctrl.alertas.push('La fila ' + (index + 1) + ' se omitirá pues no se especificó un importe Neto válido.')
    })

    $ctrl.data = orderBy(registros, 'empleado')
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/agregar/excel/component.js